// extracted by mini-css-extract-plugin
export default {"orderedList":"d4c8126d13a3","freeComplete":"b58808e9f3ab"};